import './YogoPage.css';

const YOGO_URL =
  'https://little-stars.yogo.dk/frontend/index.html?clientWebsiteReferrerUrl=https%3A%2F%2Flittle-stars.dk%2F#/login';

export default function Login() {
  return (
    <main className="yogo-page">
      <iframe
        src={YOGO_URL}
        title="Log ind - Little-Stars"
        className="yogo-page-frame"
        allow="payment"
      />
    </main>
  );
}
